import React from 'react';
import { RouteObject /*, useSearchParams*/ } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faOilWell } from '@fortawesome/free-solid-svg-icons';
import { WidgetHost, DeepDiveWidget, WidgetOutlet } from '@/core/widgets/export';
import { Permissions } from '@/core/permissions/export';
import PipelineMapPanel from '@/modules/pipelines/components/deep-dive/map/pipeline-map-panel';
import PipelineMapAssetMetricsPanel from '@/modules/pipelines/components/deep-dive/asset-metrics/pipeline-map-asset-metrics-panel';
import PipelineAnalysisPanel from '@/modules/pipelines/components/deep-dive/asset-metrics/pipeline-analysis-panel';
import { pipelineNotificationApi } from '../api';
import AssetNavigatorPanel from '@/modules/pipelines/components/deep-dive/asset-navigator/asset-navigator-panel';
import PipelineMapNoticePanel from '../components/deep-dive/notice-minimap/pipeline-map-notice-panel';
import PipelineNotificationsPanel from '@/modules/pipelines/components/deep-dive/notifications/pipeline-notifications-panel';
import PipelinePlusRoute from '@/modules/pipelines/components/deep-dive/pipeline-plus-route';
import PipelineMapLayout from '@/modules/pipelines/components/deep-dive/pipeline-map-layout';

export class PipelineMapWidget implements DeepDiveWidget {
  readonly id = 'pipeline-map';

  defaultTitle = 'Pipeline Deep Dive';

  initialize(host: WidgetHost) {}

  shouldHideToUser(permissions: string[]): boolean {
    return !permissions.includes(Permissions.PETRO_PIPELINES);
  }

  async hasPermission(permissions: string[]) {
    return !this.shouldHideToUser(permissions);
  }

  get icon(): React.ReactNode {
    return <FontAwesomeIcon icon={faOilWell} />;
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faOilWell} /> Pipeline Deep Dive
      </>
    );
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: <PipelineMapLayout />,
        children: [
          {
            element: (
              <PipelinePlusRoute>
                <WidgetOutlet />
              </PipelinePlusRoute>
            ),
            children: [
              { index: true, element: <PipelineMapPanel /> },
              { path: 'asset-metrics', element: <PipelineMapAssetMetricsPanel /> },
              { path: 'analysis', element: <PipelineAnalysisPanel /> },
              { path: 'assets', element: <AssetNavigatorPanel /> },
            ],
          },
          {
            path: 'notice/:id',
            loader: async ({ params }) => {
              try {
                return {
                  notice: await pipelineNotificationApi.getFullPipelineAlert(params.id || ''),
                };
              } catch (e) {
                return e;
              }
            },
            element: <PipelineMapNoticePanel />,
          },
          {
            path: 'history/:groupId/:id',
            loader: async ({ params }) => {
              try {
                const [notice, history] = await Promise.all([
                  pipelineNotificationApi.getFullPipelineAlert(params.id || ''),
                  pipelineNotificationApi.getPipelineEventHistory(params.groupId || '', 0),
                ]);
                return { notice, history };
              } catch (e) {
                return e;
              }
            },
            element: <PipelineMapNoticePanel />,
          },
          {
            path: 'notifications',
            element: <PipelineNotificationsPanel />,
          },
        ],
      },
    ];
  }

  get defaultRoute(): string {
    return '';
  }
}

export const pipelineMapWidget = new PipelineMapWidget();
